import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";

const folders = ["Backups", "Documents", "Logs", "Notebooks"];
const ext = ["pdf", "png", "mp4", "json"];
const createObject = (name, isFolder) => {
  let object = {
    ID: uuidv4(),
    Name: name,
    Description: faker.lorem.sentence(),
    Path: `/${uuidv4()}/`,
    IsFolder: isFolder,
    LastModified: faker.date.past(),
  };
  if (!isFolder) {
    object.Size = faker.number.int({ min: 100, max: 10000 });
  }
  return object;
};

export const allFileObjects = (path) => {
  let objects = [];
  const folderLength = path ? 1 : folders.length;
  for (var i = 0; i < folderLength; i++) {
    let object = createObject(
      path ? faker.helpers.arrayElement(folders) : folders[i],
      true
    );
    objects.push(object);
  }
  const fileLength = path ? 4 : 6;
  for (var j = 0; j < fileLength; j++) {
    const fileName = `us-east-1_${faker.number.int({
      min: 10000,
      max: 1000000,
    })}.${faker.helpers.arrayElement(ext)}`;
    let object = createObject(fileName);
    objects.push(object);
  }
  return objects;
};

const projectFolders = ["My Files", "Shared Files"];
const createProjectObject = (name, isFolder) => {
  let object = {
    ID: uuidv4(),
    Name: name,
    Label: name,
    Description: faker.lorem.sentence(),
    Path: `/${uuidv4()}/`,
    IsFolder: isFolder,
    LastModified: faker.date.past(),
  };
  if (!isFolder) {
    object.Size = faker.number.int({ min: 100, max: 10000 });
  }
  return object;
};

export const allProjectFileObjects = (path) => {
  let objects = [];
  const folderLength = path ? 1 : projectFolders.length;
  for (var i = 0; i < folderLength; i++) {
    let object = createProjectObject(
      path ? faker.helpers.arrayElement(folders) : projectFolders[i],
      true
    );
    objects.push(object);
  }
  const fileLength = path ? 4 : 0;
  for (var j = 0; j < fileLength; j++) {
    const fileName = `us-east-1_${faker.number.int({
      min: 10000,
      max: 1000000,
    })}.${faker.helpers.arrayElement(ext)}`;
    let object = createObject(fileName);
    objects.push(object);
  }
  return objects;
};
